import axios from "axios";
import {http} from "Services/Http/HttpClient";
import {getAuth} from "Services/Security/AuthService";
import {DropzoneFile} from "Components/FileUpload/FileUpload";

export const updateConfig = async (id: string, value: string) => {
    return await http.patch('/config/' + id, {
        value: value
    })
}

export const uploadConfigFile = async (file: DropzoneFile, configKey: string) => {
    let data = new FormData()
    data.append('file', file.file)
    data.append('key', configKey)

    const fhttp = axios.create({
        baseURL: process.env.REACT_APP_API_URL,
        headers: {
            "Content-type": "multipart/form-data;",
            "Authorization": getAuth()
        }
    })

    return fhttp.post('/config/upload', data)
}
